<template>
    <div class="d-flex flex-column align-items-center text-center px-2">
        <b-form-group
                v-if="targets.length"
                id="works-form"
                label="🔨 Выберите вид выполненных работ"
                label-for="peopleCount"
                content-cols="12"
        >
            <div class="d-flex justify-content-between">
                <v-select v-model="value" :options="targets" label="workName" append-to-body :clearable="false"
                          class="w-100"/>
                <b-button size="sm" variant="success" class="ml-2" @click="onWorkSelect" :disabled="!value">
                    Добавить
                </b-button>
            </div>
        </b-form-group>
        <b-card v-for="item in selectedWorks" :key="item.work_id" class="w-100 mb-2">
            <template #header>
                <h4 class="mb-0">{{ item.name }}
                    <i class="fas fa-trash-alt text-danger small ml-5 position-absolute"
                       style="right: 20px; top: 15px"
                       @click="() => onDelete(item.work_id)"
                    />
                </h4>
                <div class="text-info">
                    Объем работ по договору: <span class="font-weight-bold">{{ item.targetValue }}</span> {{item.unitOfMeasurement}}
                </div>
                <div class="text-info">
                    Выполнено по виду работ: <span class="font-weight-bold">{{ item.completedSumFromAllShifts.toFixed(2) }}</span> {{item.unitOfMeasurement}}
                    ({{ ((item.completedSumFromAllShifts * 100) / item.targetValue).toFixed(2) }} %)
                </div>
                <div class="text-info">
                    Осталось по виду работ: <span
                        class="font-weight-bold">{{ item.targetValue - item.completedSumFromAllShifts }}</span> {{item.unitOfMeasurement}}
                    ({{ (100 - ((item.completedSumFromAllShifts * 100) / item.targetValue)).toFixed(2) }} %)
                </div>
            </template>
            <b-form-group
                    :id="`completed-form_${item.work_id}`"
                    :label="`Введите объем работ, выполненный за эту смену`"
                    :label-for="`completed-form_${item.work_id}`"
                    label-class="font-weight-bold"
            >
                <div class="d-inline-flex align-items-center">
                    <span class="ml-2 mr-2">🔨</span>
                    <input type="number" :id="`completed-form_${item.work_id}`" v-model="item.completed" placeholder="0"
                           @change="updateCache"/>
                    <span class="ml-2">{{ item.unitOfMeasurement }}</span>
                </div>
            </b-form-group>
            <b-form-group
                    :id="`peopleCount-form_${item.work_id}`"
                    label="Сколько рабочих участвовало в этом виде работ?"
                    :label-for="`peopleCount-form_${item.work_id}`"
                    label-class="font-weight-bold"
            >
                <div class="d-inline-flex align-items-center">
                    <span class="ml-2 mr-2">👷🏻‍♂️🔁 </span>
                    <input type="number" :id="`peopleCount-form_${item.work_id}`" v-model="item.peopleCount" placeholder="0"
                           @change="updateCache" min="0"/>
                    <span class="ml-2">чел.</span>
                </div>
            </b-form-group>
            <b-button v-if="item.materials.length" v-b-toggle="`materials-${item.work_id}`" variant="light" size="sm">
              🧱🤏🏻Материалы
            </b-button>
            <b-collapse :id="`materials-${item.work_id}`" class="mt-2" :visible="true" v-if="item.materials.length">
                <div class="step-four-materials-table">
                    <b-table
                        responsive="sm"
                        table-class="no-sticky"
                        :items="item.materials"
                        :fields="fields"
                        small
                        striped
                    >
                        <template v-slot:cell(used)="data">
                            <b-form-input
                                type="number"
                                v-model="data.item.used"
                                size="sm"
                                class="step-four-materials-used-input"
                                @change="updateCache"
                                placeholder="0"
                            />
                        </template>
                    </b-table>
                </div>
            </b-collapse>
        </b-card>
        <div class="my-2 mt-md-5">
            <h5>
                <b-badge variant="warning">🏃🏼‍♂Остаток рабочих по смене:
                    <span :class="`${peopleBalance === 0 ? 'text-success': 'text-danger'}`"
                          style="font-size: 20px">{{ peopleBalance }}</span>
                </b-badge>
            </h5>
            <div class="text-danger" v-if="peopleBalance !== 0">
                ❗️Остаток рабочих должен быть 0 иначе дальше "ты не пройдёшь! 👹🔥 🧙‍♂️
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StepFour",
    computed: {
        selectedWorks() {
            return this.$store.state.shiftReport.selectedWorks;
        },
        targets() {
            const {selectedWorks} = this;
            return this.$store.state.shiftReport.targets
                .filter(el => !selectedWorks.some(s => s.work_id === el.work_id))
                .map(el => {
                    el.workName = el.Work.name;
                    if (el.work_name_project) {
                        el.workName += ` (${el.work_name_project})`;
                    }
                    return el;
                });
        },
        peopleCount() {
            return this.$store.state.shiftReport.peopleCount;
        },
        peopleBalance() {
            const {peopleCount, selectedWorks} = this;
            return peopleCount - (selectedWorks.reduce((acc, cur) => acc += Number(cur.peopleCount), 0))
        }
    },
    data() {
        return {
            value: null,
            fields: [
                {
                    label: `Имя`,
                    key: `name`
                },
                {
                    label: `Ед. изм.`,
                    key: `unitOfMeasurement`
                },
                {
                    label: `Затрачено`,
                    key: `used`,
                    tdClass: 'step-four-materials-used-cell'
                }
            ]
        }
    },
    methods: {
        async onWorkSelect() {
            const {targets, selectedWorks, value, $store} = this;
            const work = targets.find(el => el.work_id === value.work_id);
            const materials = await this.$store.dispatch(`shiftReport_getMaterials`, work);
            let workName = work.Work.name;
            if (work.work_name_project) {
                workName += ` (${work.work_name_project})`;
            }
            $store.commit(`shiftReport_setSelectedWorks`, [...selectedWorks].concat([{
                work_id: value.work_id,
                row_id: value.row_id,
                name: workName,
                peopleCount: null,
                completed: null,
                unitOfMeasurement: work.Work.unit_of_measurement,
                materials: materials.map(el => ({
                    id: el.Material.id,
                    target_material_id: el.id,
                    name: el.Material.name,
                    unitOfMeasurement: el.Material.measures,
                    used: null
                })),
                targetValue: value.value,
                completedSumFromAllShifts: value.completed
            }]));
            this.updateCache();
            this.value = null;
        },
        onDelete(id) {
            this.$store.commit(`shiftReport_setSelectedWorks`, this.selectedWorks.filter(el => el.work_id !== id));
        },
        updateCache() {
            this.$store.dispatch(`shiftReport_updateCache`);
        }
    },
    mounted() {
        this.$emit(`can-continue`, {
            value: this.peopleBalance === 0
        });
    },
    watch: {
        peopleBalance(v) {
            this.$emit(`can-continue`, {
                value: v === 0
            });
        }
    }
}
</script>

<style scoped lang="scss">
/* iOS/WebKit: table-responsive-sm + overflow-x:auto + sticky thead ломали отрисовку tbody */
.step-four-materials-table ::v-deep .table-responsive-sm {
    @media (max-width: 575.98px) {
        overflow-x: visible !important;
    }
}

.step-four-materials-table ::v-deep .step-four-materials-used-cell {
    min-width: 0;
    vertical-align: middle;
}

.step-four-materials-table ::v-deep .step-four-materials-used-input {
    min-width: 0;
    max-width: 100%;
}
</style>
